<template>
  <div class="apply-area flex-r-center">
    <div class="card-width">
      <el-card>
        <div slot="header" class="card-wrap flex-center-center fz24">申领单位电子公章</div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm"
                 v-loading="loading">
          <div class="content">
            <div class="top-area">
              <div class="area-title">选择印章</div>
              <el-form-item label="印章类别" style="text-align: left">
                <el-radio v-model="ruleForm.sealType" v-for="(item, index) in sealTypes" :key="index"
                          :label="index + 1" border>{{ item.productName }}
                </el-radio>
              </el-form-item>
              <div class="seal-confirm">
                <el-form-item label="申请印章">
                  <div class="seal-list flex-center-wrap">
                    <div class="seal-item fz16 mr20 pointer" v-for="(item, index) in sealData" :key="index"
                         @click="handleSeal(item, index)" :class="item.isChosen ? 'seal-item-active ' : ''">
                      {{ item.name }}
                      <img v-if="item.isChosen" class="img-chosen" :src="chosenUrl" alt/>
                    </div>
                  </div>
                </el-form-item>
              </div>
            </div>
            <div class="top-area" style="border-top: 1px solid #eee">
              <div class="seal-confirm">
                <el-form-item label="印章预览">
                  <div class="seal-list flex-center-wrap">
                    <div class="image-view mr20 mb10" v-show="item.isChosen" v-for="(item, index) in sealData"
                         :key="index">
                      <el-upload
                          :ref="'upload' + index"
                          class="image-box"
                          :show-file-list="false"
                          :before-upload="(e) => handleBeforeUpload(e, item, index)"
                          :on-change="onChangeFront"
                          action="/"
                          accept="image/*"
                      >
                        <div class="w100">
                          <el-button size="mini" type="primary" @click="openSealVisible('upload',item,index)">上传印模
                          </el-button>
                        </div>
                        <div class="image-pre-box">
                          <img class="image-box-img" :src="item.sealImage"/>
                          <el-button size="small" v-if="item.custom && item.custom === '1'" class="img-del-btn"
                                     type="danger" @click="handleDelImg(item, index)" icon="el-icon-delete"
                                     circle></el-button>
                        </div>
                        <el-button slot="trigger" size="mini" type="primary" style="display: none;">上传印模</el-button>
                      </el-upload>
                      <div class="fc3 lh20 mt5">{{ item.name }}</div>
                      <el-button size="mini" type="primary" @click="openSealVisible('generate',item,index)">生成印模
                      </el-button>
                    </div>
                  </div>
                </el-form-item>
              </div>
            </div>
            <el-form-item label="">
              <div class="seal-uploader__tip">
                <strong style="color: #666">印模图上传须知：</strong><br>
                png格式，且不超过60kb，画布颜色透明。
              </div>
            </el-form-item>
            <div class="bottom-area" v-if="ruleForm.sealType === 2">
              <div class="area-title">
                收货地址
                <span class="fz12 fc9 ml10">请准确填写你的收货地址</span>
              </div>
              <el-row class="mt20">
                <el-col :span="24">
                  <el-form-item prop="consigneeName" class="pass-form" label="收货人">
                    <el-input type="text" v-model="ruleForm.consigneeName"
                              placeholder="请输入收货人姓名"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item prop="consigneePhone" class="pass-form" label="收货电话">
                    <el-input type="text" v-model="ruleForm.consigneePhone"
                              placeholder="请输入收货人联系电话"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item prop="consigneeAddress" class="pass-form" label="收货地址">
                    <el-input type="text" v-model="ruleForm.consigneeAddress"
                              placeholder="请输入收货地址"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="bottom-area" v-if="!isLogin">
              <div class="area-title">
                签署密码设置
                <span class="fz12 fc9 ml10">密码必须为6位数字</span>
              </div>
              <el-row class="mt20">
                <el-col :span="24">
                  <el-form-item prop="pinCode" class="pass-form" label="签署密码">
                    <el-input type="number" :maxlength="6" show-password v-model="ruleForm.pinCode"
                              placeholder="请设置独立签署密码"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item prop="pinCodeConfirm" class="pass-form" label="确认签署密码">
                    <el-input type="number" :maxlength="6" show-password v-model="ruleForm.pinCodeConfirm"
                              placeholder="请确认独立签署密码"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <el-form-item>
              <el-button class="next-button" type="primary" @click="submitForm('ruleForm')">确认申领</el-button>
            </el-form-item>
          </div>
        </el-form>
      </el-card>
    </div>
    <sealwidth-and-height
        ref="sealwidthAndHeight"
        @uploadSeal="uploadSeal"
        :visible.sync="sealVisible"
    />
  </div>
</template>
<script>
import Cookie from 'js-cookie'
import SealwidthAndHeight from "@/pages/customerEnterprise/components/sealwidthAndHeight.vue";

export default {
  components: {SealwidthAndHeight},
  data() {
    const validPass = (rule, value, callback) => {
      let reg = /^\d{6}$/;
      if (value === "") {
        callback(new Error("请设置独立签署密码"));
      } else if (!reg.test(value)) {
        callback(new Error("密码必须为6位数字"));
      } else {
        callback();
      }
    };
    const validPassCon = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入确认独立签署密码"));
      } else if (value !== this.ruleForm.pinCode) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    const validPhone = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (value === "") {
        callback(new Error("请输入手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的手机号码"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      chosenUrl: require('@/assets/login/icon-pay-chosen.png'),
      ruleForm: {
        sealType: 1,
        pinCode: undefined,
        pinCodeConfirm: undefined,
        consigneeName: undefined,
        consigneePhone: undefined,
        consigneeAddress: undefined,
      },
      selectionList: [],
      rules: {
        consigneeName: [
          {required: true, message: '收货人不能为空', trigger: 'blur'}
        ],
        consigneePhone: [
          {required: true, validator: validPhone, trigger: "blur"}
        ],
        consigneeAddress: [
          {required: true, message: '收货地址不能为空', trigger: 'blur'}
        ],
        pinCode: [
          {required: true, validator: validPass, trigger: "blur"}
        ],
        pinCodeConfirm: [
          {required: true, validator: validPassCon, trigger: "blur"}
        ]
      },
      personImg: "",
      userId: "",
      sealData: [],
      sealTypes: [],
      sealVisible: false
    };
  },
  computed: {
    user() {
      return this.$store.state.account.user
    },
    isLogin() {
      return this.user && this.user.userId
    }
  },
  mounted() {
    this.userId = this.$auth.getUserId() || this.user.userId
    this.getSealType();
  },
  methods: {
    openSealVisible(type, item, index) {
      this.sealVisible = true
      this.$refs.sealwidthAndHeight.open(type, item, index)
    },
    uploadSeal(e) {
      this.sealVisible = false
      if (e.type == 'generate') {
        this.getImg(e.item, e.index)
      } else if (e.type == 'upload') {
        let name = 'upload' + e.index
        console.log(this.$refs[name])
        console.log(e.index)
        this.$refs[name][0].$el.querySelector('input[type=file]').click()
      }
    },
    getImg(item, index) {
      let creditCode = Cookie.get("businessCreditCode") || this.user.code
      let params = {
        sealTypeCode: item.code,
        businessCreditCode: creditCode,
        width: item.width,
        height: item.height
      };

      this.loading = true
      this.$http.post(this.$api.register.genSealImg, params).then(res => {
        if (res.data.code == 200) {
          item.sealImage = "data:image/jpeg;base64," + res.data.data.sealImage;
          item.custom = "0"
          item.sealImageId = res.data.data.sealImageId
          this.$set(this.sealData, index, item)
        }
        this.loading = false
      });
    },
    getSealType() {
      this.$http.post(this.$api.user.getSealType, {type: "business"}, {"Content-Type": "application/x-www-form-urlencoded"}).then(res => {
        if (res.data.code == 200) {
          this.sealData = res.data.data || []
        }
      })

      this.$http.post(this.$api.register.getProductsInfo, {
        productType: 'seal',
        type: 'user',
        userId: this.userId
      }).then(res => {
        if (res.data.code == 200) {
          if (res.data.data.length > 0) {
            this.sealTypes = res.data.data || [];
          } else {
            this.$message.error('暂无商品信息')
          }
        }
      });
    },
    handleSeal(item, index) {
      if (!item.isChosen) {
        item.isChosen = true;
        this.selectionList.push(item);
        if (item.code == "01" || item.code == "04" || item.code == "06") {
          this.$set(this.sealData[index], 'width', '42')
          this.$set(this.sealData[index], 'height', '42')
        } else if (item.code == "02") {
          this.$set(this.sealData[index], 'width', '43')
          this.$set(this.sealData[index], 'height', '30')
        } else if (item.code == "03") {
          this.$set(this.sealData[index], 'width', '40')
          this.$set(this.sealData[index], 'height', '30')
        } else if (item.code == "05") {
          this.$set(this.sealData[index], 'width', '20')
          this.$set(this.sealData[index], 'height', '20')
        }
        // if (!item.sealImage) {
        //   this.getImg(item,index);
        // }
      } else {
        item.isChosen = false;
        this.selectionList = this.selectionList.filter(li => li.code != item.code);
      }

      this.$set(this.sealData, index, item)
    },
    submitForm() {
      if (!this.ruleForm.sealType) {
        this.$message.warning('请选择印章类别')
        return;
      }

      if (!this.selectionList || !this.selectionList.length) {
        this.$message.warning('请选择申请的印章')
        return;
      }

      if (this.isLogin && this.ruleForm.sealType === 1) {
        let _sealType = this.sealTypes[this.ruleForm.sealType - 1]
        sessionStorage.setItem('selection', JSON.stringify({
          type: _sealType,
          seals: this.selectionList
        }))
        this.$router.push({path: "/qys/orderPayOff"});
        return;
      }

      this.$refs.ruleForm.validate(async value => {
        if (value) {
          let posts = []
          if (this.ruleForm.sealType === 2) {
            let conReq = this.$http.post(this.$api.register.consigneeInfo, {
              "consigneeAddress": this.ruleForm.consigneeAddress,
              "consigneeName": this.ruleForm.consigneeName,
              "consigneePhone": this.ruleForm.consigneePhone,
              "onlineUserId": this.userId
            })

            posts.push(conReq);
          }

          if (!this.isLogin) {
            let pinReq = this.$http.post(this.$api.register.setPersonalPin, {
              userId: this.userId,
              pinCode: this.ruleForm.pinCode
            })
            posts.push(pinReq);
          }

          this.$http.all(posts).then(resps => {
            let consigneeCacheId = null
            for (let resp of resps) {
              if (resp.data.code != 200) {
                throw new Error(resp.data.msg || 'error')
              }
              if (resp.data.data.consigneeCacheId) {
                consigneeCacheId = resp.data.data.consigneeCacheId
              }
            }

            let _sealType = this.sealTypes[this.ruleForm.sealType - 1]
            sessionStorage.setItem('selection', JSON.stringify({
              type: _sealType,
              consigneeCacheId: consigneeCacheId,
              seals: this.selectionList
            }))
            this.$router.push({path: "/qys/orderPayOff"});
          }).catch((err) => {
            this.$message.error(err || '提交出错了')
          });
        }
      });
    },
    handleDelImg(item, index) {
      this.getImg(item, index)
    },
    onChangeFront(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    handleBeforeUpload(file, item, index) {
      const isLt2M = file.size / 1024 <= 60
      if (!isLt2M) {
        this.$message.error('上传印模图大小不能超过60KB!')
        return false
      }

      const reader = new FileReader();
      reader.readAsDataURL(file); // 转换为Base64
      reader.onload = (e) => {
        let position = e.target.result.indexOf("base64");
        let lastIndex = position * 1 + 7;
        let base = e.target.result.slice(lastIndex);

        let creditCode = Cookie.get("businessCreditCode") || this.user.code
        this.$http.post(this.$api.register.upload, {
          type: item.code,
          imageBase64: base,
          businessCode: creditCode,
          width: item.width,
          height: item.height
        }).then((res) => {
          item.sealImage = e.target.result;
          item.custom = "1"
          item.sealImageId = res.data.data.sealImageId
          this.$set(this.sealData, index, item)
        }).catch((err) => {
          this.$message.error('印模图上传失败');
        });
      };

      return false; // 阻止默认上传行为
    }
  }
};
</script>
<style lang="less" scoped>
::v-deep .el-card {
  width: 1200px;
  min-height: 730px;
}

::v-deep .el-card__header {
  display: flex;
  align-items: center;
  justify-content: center;
  // margin-bottom: 20px;
}

.content {
  margin-left: 75px !important;
  margin-right: 75px !important;
  padding-bottom: 48px;

  .seal-uploader__tip {
    color: #999;
    line-height: 1.5;
    text-align: left;
  }

  .top-area {
    .seal-confirm {
      display: flex;
      align-items: flex-start;
      padding: 20px 0 0;

      .seal-list {
        .seal-item {
          position: relative;
          // width: 18%;
          padding: 0px 20px;
          background: #f5f7fa;
          color: #1d76f9;
          border-radius: 6px;

          &:last-child {
            margin-right: 0 !important;
          }

          .img-chosen {
            position: absolute;
            bottom: 0;
            right: 0;
            width: 14px;
            height: 14px;
          }
        }

        .seal-item-active {
          border: 1px solid #1880ff;
        }
      }
    }

    .image-view {
      .img-del-btn {
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: -20px;
        margin-left: -20px;
      }

      .image-box {
        width: 150px;
        height: 190px;
        padding: 0 5px;
        overflow: hidden;
        border: 1px solid #ccc;
        display: flex;
        flex-direction: column;
      }

      .image-pre-box {
        position: relative;
        flex: 1;
        display: flex;
        align-items: center;
      }

      .image-box-img {
        width: 100%;
      }
    }
  }

  .bottom-area {
    padding-top: 20px;
    border-top: 1px solid #eee;
  }
}

.area-title {
  margin: 10px 0;
  padding-left: 14px;
  position: relative;
  font-size: 18px;
  text-align: left;

  &:after {
    content: "";
    position: absolute;
    width: 4px;
    height: 18px;
    background: #1d76f9;
    left: 0;
    bottom: 50%;
    transform: translateY(50%);
  }
}

.next-button {
  width: 350px;
  font-size: 16px;
  padding: 11px 20px !important;
  margin-top: 20px;
  box-shadow: 0 2px 4px 0 rgba(64, 129, 255, 0.4);
}

.lh20 {
  line-height: 20px;
}

::v-deep .el-form {
  padding: 0;
}

::v-deep .el-form-item {
  width: 100%;
}

.pass-form {
  ::v-deep .el-form-item__content {
    width: 370px;
  }
}

//去掉number输入框的上下箭头
::v-deep input::-webkit-outer-spin-button {
  -webkit-appearance: none;
}

::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

::v-deep input[type="number"] {
  -moz-appearance: textfield;
}

// 解决input number框输入中文后光标上移的问题
::v-deep .el-input__inner {
  line-height: 1px !important;
}
</style>
